module.exports = __webpack_public_path__ + "static/media/09.f3f8f5b0.jpg";